module.exports = __webpack_public_path__ + "img/EXPORT.4d894a9f.svg";